/**
 * Fetch All Add-On Products API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../axiosInstance';
import { FetchAddOnProductsResponse } from './types';

export const fetchAllAddOnProducts = async (): Promise<FetchAddOnProductsResponse> => {
  const response = await axiosInstance.get<FetchAddOnProductsResponse>('/api/add-on-products');
  return response.data;
};
